// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactDates = require("react-dates");
var MomentTimezone = require("moment-timezone");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var MomentRe$ReactHooksTemplate = require("../../MomentRe.res.js");
var DateFilter$ReactHooksTemplate = require("./dateFilter.res.js");
var DateSelected$ReactHooksTemplate = require("./dateSelected.res.js");
var Organization$ReactHooksTemplate = require("../../settings/organization.res.js");
var ReactDatePicker$ReactHooksTemplate = require("../../common/ReactDatePicker.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../../CurrentOrganization.res.js");

function DateFilterForm(props) {
  var disableDatePicker = props.disableDatePicker;
  var displayFilterPills = props.displayFilterPills;
  var onChange = props.onChange;
  var filter = props.filter;
  var match = React.useState(function (param) {
        var date = DateFilter$ReactHooksTemplate.selected(filter);
        var date$1 = DateFilter$ReactHooksTemplate.selected(filter);
        return {
                startDate: date !== undefined ? DateSelected$ReactHooksTemplate.from(date) : undefined,
                endDate: date$1 !== undefined ? DateSelected$ReactHooksTemplate.to_(date$1) : undefined,
                focusedInput: null,
                focusedDate: disableDatePicker ? "One Month" : "Custom Date"
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var organizationProfile = match$1[0];
  var handleOffSetFilter = function (duration) {
    var startDate = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.subtract(duration, Moment()));
    var endDate = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.endOf("day", Moment()));
    Curry._1(setState, (function (state) {
            return {
                    startDate: startDate,
                    endDate: endDate,
                    focusedInput: state.focusedInput,
                    focusedDate: state.focusedDate
                  };
          }));
    Curry._1(onChange, {
          TAG: "Date",
          _0: DateFilter$ReactHooksTemplate.setSelected(DateSelected$ReactHooksTemplate.make(startDate, endDate), filter)
        });
  };
  var handleYesterdayFilter = function (param) {
    var startDate = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.subtract(Moment.duration(1, "days"), MomentRe$ReactHooksTemplate.Moment.startOf("day", Moment())));
    var endDate = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.subtract(Moment.duration(1, "days"), MomentRe$ReactHooksTemplate.Moment.subtract(Moment.duration(400, "milliseconds"), MomentRe$ReactHooksTemplate.Moment.endOf("day", Moment()))));
    Curry._1(setState, (function (state) {
            return {
                    startDate: startDate,
                    endDate: endDate,
                    focusedInput: state.focusedInput,
                    focusedDate: state.focusedDate
                  };
          }));
    Curry._1(onChange, {
          TAG: "Date",
          _0: DateFilter$ReactHooksTemplate.setSelected(DateSelected$ReactHooksTemplate.make(startDate, endDate), filter)
        });
  };
  var convertToOrgTimeZone = function (date) {
    var dateInString = date.format("YYYY-MM-DD HH:mm:ss");
    return MomentTimezone.tz(dateInString, Organization$ReactHooksTemplate.timeZone(organizationProfile));
  };
  var isValidDate = function (date) {
    return date.isSameOrBefore(MomentRe$ReactHooksTemplate.Moment.endOf("day", Moment()));
  };
  var onDatesChange = function (dateRangeTuple) {
    var rangeTuple = ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getDates(dateRangeTuple);
    var startDate = ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getStartDate(rangeTuple);
    var endDate = ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getEndDate(rangeTuple);
    var selectedStartDate = !(startDate == null) && isValidDate(startDate) ? Caml_option.some(convertToOrgTimeZone(startDate)) : undefined;
    var selectedEndDate = !(endDate == null) && isValidDate(endDate) ? Caml_option.some(convertToOrgTimeZone(MomentRe$ReactHooksTemplate.Moment.endOf("day", endDate))) : undefined;
    Curry._1(setState, (function (state) {
            return {
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    focusedInput: state.focusedInput,
                    focusedDate: state.focusedDate
                  };
          }));
  };
  var closeCalendar = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    startDate: state.startDate,
                    endDate: state.endDate,
                    focusedInput: null,
                    focusedDate: state.focusedDate
                  };
          }));
  };
  var isSameCalendarDay = function (a, b) {
    return a.format("YYYY-MM-DD") === b.format("YYYY-MM-DD");
  };
  var defaultRangeForReset = function (param) {
    var match = DateFilter$ReactHooksTemplate.defaultDateFilter(filter);
    if (match !== undefined) {
      switch (match) {
        case "current_day" :
            var now = Moment();
            var start = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.startOf("day", now));
            var end_ = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.endOf("day", now));
            return [
                    start,
                    end_
                  ];
        default:
          
      }
    }
    var now$1 = Moment();
    var start$1 = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.startOf("month", now$1));
    var end_$1 = Caml_option.some(MomentRe$ReactHooksTemplate.Moment.endOf("month", now$1));
    return [
            start$1,
            end_$1
          ];
  };
  var match$2 = state.startDate;
  var canApply = match$2 !== undefined;
  var checkForOutsideRange = function (date) {
    return !isValidDate(date);
  };
  var calendarInfo = function (param) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("button", {
                        children: "Apply",
                        className: "px-3 py-1.5 text-sm font-medium rounded border border-gray-300 bg-white hover:bg-verdigris hover:text-white disabled:opacity-50 disabled:cursor-not-allowed",
                        disabled: !canApply || disableDatePicker,
                        type: "button",
                        onClick: (function (param) {
                            var match = state.startDate;
                            var match$1 = state.endDate;
                            if (match === undefined) {
                              return ;
                            }
                            var start = Caml_option.valFromOption(match);
                            if (match$1 !== undefined) {
                              var end_ = Caml_option.valFromOption(match$1);
                              var match$2;
                              if (isSameCalendarDay(start, end_)) {
                                var startInOrg = convertToOrgTimeZone(start);
                                var startOfDayInOrg = MomentRe$ReactHooksTemplate.Moment.startOf("day", startInOrg);
                                var endOfDayInOrg = MomentRe$ReactHooksTemplate.Moment.endOf("day", startInOrg);
                                match$2 = [
                                  startOfDayInOrg,
                                  endOfDayInOrg
                                ];
                              } else {
                                match$2 = [
                                  start,
                                  end_
                                ];
                              }
                              Curry._1(onChange, {
                                    TAG: "Date",
                                    _0: DateFilter$ReactHooksTemplate.setSelected(DateSelected$ReactHooksTemplate.make(Caml_option.some(match$2[0]), Caml_option.some(match$2[1])), filter)
                                  });
                              return closeCalendar();
                            }
                            var startInOrg$1 = convertToOrgTimeZone(start);
                            var startOfDayInOrg$1 = MomentRe$ReactHooksTemplate.Moment.startOf("day", startInOrg$1);
                            var endOfDayInOrg$1 = MomentRe$ReactHooksTemplate.Moment.endOf("day", startInOrg$1);
                            Curry._1(onChange, {
                                  TAG: "Date",
                                  _0: DateFilter$ReactHooksTemplate.setSelected(DateSelected$ReactHooksTemplate.make(Caml_option.some(startOfDayInOrg$1), Caml_option.some(endOfDayInOrg$1)), filter)
                                });
                            closeCalendar();
                          })
                      }),
                  JsxRuntime.jsx("button", {
                        children: "Reset",
                        className: "px-3 py-1.5 text-sm font-medium rounded border border-gray-300 bg-white hover:bg-verdigris  hover:text-white",
                        disabled: disableDatePicker,
                        type: "button",
                        onClick: (function (param) {
                            var match = defaultRangeForReset();
                            var endDate = match[1];
                            var startDate = match[0];
                            Curry._1(setState, (function (state) {
                                    return {
                                            startDate: startDate,
                                            endDate: endDate,
                                            focusedInput: state.focusedInput,
                                            focusedDate: state.focusedDate
                                          };
                                  }));
                          })
                      })
                ],
                className: "flex gap-2 p-3 border-t border-gray-200 mt-2",
                onClick: (function (e) {
                    e.stopPropagation();
                  })
              });
  };
  var onFocusChange = function (focusedInput) {
    Curry._1(setState, (function (state) {
            var nextFocused;
            if (focusedInput == null) {
              var match = state.startDate;
              nextFocused = match !== undefined ? state.focusedInput : null;
            } else {
              nextFocused = focusedInput;
            }
            return {
                    startDate: state.startDate,
                    endDate: state.endDate,
                    focusedInput: nextFocused,
                    focusedDate: "Custom Date"
                  };
          }));
  };
  return JsxRuntime.jsx("div", {
              children: displayFilterPills === true ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Transaction Date",
                              className: "mb-3"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("p", {
                                                      children: state.focusedDate,
                                                      className: "mr-5-px"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "h-7-px filter-gray-400",
                                                      src: Image$ReactHooksTemplate.chevronDown
                                                    })
                                              ],
                                              className: "flex items-center text-sm font-normal w-40 justify-between\n                           predefined_dates rounded cursor-pointer"
                                            }),
                                        JsxRuntime.jsxs("ul", {
                                              children: [
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "One Day",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(1, "days"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "One Day"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "Yesterday",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleYesterdayFilter();
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "Yesterday"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "One Week",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(1, "weeks"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "One Week"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "One Month",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(1, "months"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "One Month"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "3 Months",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(3, "months"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "3 Months"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "6 Months",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(6, "months"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "6 Months"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "One Year",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white rounded",
                                                            onClick: (function (param) {
                                                                handleOffSetFilter(Moment.duration(1, "years"));
                                                                Curry._1(setState, (function (state) {
                                                                        return {
                                                                                startDate: state.startDate,
                                                                                endDate: state.endDate,
                                                                                focusedInput: state.focusedInput,
                                                                                focusedDate: "One Year"
                                                                              };
                                                                      }));
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    })
                                              ],
                                              className: "dropdown-list shadow text-gray-800 text-sm cursor-pointer"
                                            })
                                      ],
                                      className: "dropdown mr-20-px"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("button", {
                                            children: "D-1",
                                            className: "border border-gray-300 p-2 hover:bg-palatinateblue hover:text-white rounded mr-1 hidden",
                                            id: "d-minus-one",
                                            onClick: (function (param) {
                                                handleYesterdayFilter();
                                                Curry._1(setState, (function (state) {
                                                        return {
                                                                startDate: state.startDate,
                                                                endDate: state.endDate,
                                                                focusedInput: state.focusedInput,
                                                                focusedDate: "Yesterday"
                                                              };
                                                      }));
                                              })
                                          }),
                                      className: "flex text-xs"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(ReactDates.DateRangePicker, {
                                            startDate: state.startDate,
                                            startDateId: "your_unique_start_date_id",
                                            endDate: state.endDate,
                                            endDateId: "your_unique_end_date_id",
                                            disabled: disableDatePicker,
                                            onDatesChange: onDatesChange,
                                            focusedInput: Caml_option.some(state.focusedInput),
                                            onFocusChange: onFocusChange,
                                            displayFormat: "DD/MM/YYYY",
                                            openDirection: "down",
                                            hideKeyboardShortcutsPanel: true,
                                            enableOutsideDays: true,
                                            isOutsideRange: checkForOutsideRange,
                                            small: true,
                                            orientation: "horizontal",
                                            numberOfMonths: 1,
                                            readOnly: true,
                                            minimumNights: 0,
                                            renderCalendarInfo: calendarInfo
                                          }),
                                      className: "flex items-center gap-2"
                                    })
                              ],
                              className: "flex gap-2"
                            })
                      ]
                    }) : JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ReactDates.DateRangePicker, {
                            startDate: state.startDate,
                            startDateId: "your_unique_start_date_id",
                            endDate: state.endDate,
                            endDateId: "your_unique_end_date_id",
                            disabled: disableDatePicker,
                            onDatesChange: onDatesChange,
                            focusedInput: Caml_option.some(state.focusedInput),
                            onFocusChange: onFocusChange,
                            displayFormat: "DD/MM/YYYY",
                            openDirection: "down",
                            hideKeyboardShortcutsPanel: true,
                            enableOutsideDays: true,
                            isOutsideRange: checkForOutsideRange,
                            small: true,
                            orientation: "horizontal",
                            numberOfMonths: 1,
                            readOnly: true,
                            minimumNights: 0,
                            renderCalendarInfo: calendarInfo
                          }),
                      className: "flex items-center gap-2"
                    }),
              className: displayFilterPills ? "text-darkcharcoal p-5 border-b border-gray-400" : ""
            });
}

var make = DateFilterForm;

exports.make = make;
/* react Not a pure module */
